import { useEffect, useRef } from 'react';
import { usePrevious, useHoneycombTheme } from '@honeycomb/ui-core';
import { getPinSVGData } from './getPinSVGData';
export function MapMarker({ map, coordinates, title, selected, onClick, onSelected }) {
    const markerRef = useRef(null);
    const prevSelected = usePrevious(selected);
    const { theme } = useHoneycombTheme();
    const markerIcons = {
        default: {
            url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(getPinSVGData(theme.fn.getColor('primary.base')))}`,
        },
        selected: {
            url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(getPinSVGData(theme.fn.getColor('accent.base')))}`,
        },
    };
    useEffect(() => {
        if (markerRef.current) {
            return undefined;
        }
        // Create the marker on mount
        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: coordinates,
            title,
        });
        if (map !== undefined && map !== null) {
            marker.map = map;
        }
        marker.addListener('click', () => {
            if (onClick) {
                onClick(marker);
            }
        });
        markerRef.current = marker;
        return () => {
            // Marker unmounted
            const { current: currentMarker } = markerRef;
            if (currentMarker !== null) {
                currentMarker.map = null;
            }
        };
    }, [coordinates, map, onClick, title]);
    useEffect(() => {
        const { current: marker } = markerRef;
        if (marker == null || map === undefined) {
            return;
        }
        marker.map = map;
    }, [map]);
    useEffect(() => {
        // "Selected" prop has changed;
        const { current: marker } = markerRef;
        if (marker !== null && selected !== prevSelected) {
            const img = document.createElement('img');
            img.src = selected ? markerIcons.selected.url : markerIcons.default.url;
            marker.content = img;
            if (selected && onSelected) {
                onSelected(marker);
            }
        }
    }, [onSelected, selected, prevSelected, markerIcons.selected, markerIcons.default]);
    return null;
}
